import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryV1 } from './baseQueryV1';

export const salaryApi = createApi({
  reducerPath: 'salaryApi', // updated for clarity
  baseQuery: baseQueryV1,
  tagTypes: ['SalarySlip'],
  endpoints: (builder) => ({
    createSalarySlip: builder.mutation({
      query: (payload) => ({
        url: `salary/generate-payslip`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['SalarySlip'], // optional: refetch if needed
    }),
    getPaySlip: builder.query({
      query: (params) => ({
        url: `salary/get-payslip`,
        method: 'GET',
        params,
      }),
      invalidatesTags: ['SalarySlip'], // optional: refetch if needed
    }),
    updateSettings: builder.mutation({
      query: ({ payload, id }) => ({
        url: `settings/${id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['SalarySlip'], // optional
    }),
    calculateSalary: builder.query({
      query: ({ id, month, year }) => ({
        url: `salary/calculate-salary/${id}?month=${month}&year=${year}`,
        method: 'GET',
      }),
    }),
    getSalaryInformation: builder.mutation({
      query: ({ password }) => ({
        url: `salary/get-salary-info`,
        method: 'POST',
        body: { password },
      }),
    }),
    getAllUsersSalaries: builder.query({
      query: ({ month, year }) => ({
        url: `salary/all-users-salary-month?month=${month}&year=${year}`,
        method: 'GET',
      }),
      providesTags: ['SalarySlip'],
    }),
    bulkSavePayDate: builder.mutation({
      query: (payload) => ({
        url: `salary/bulk-save-pay-date`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['SalarySlip'],
    }),
    verifyPayslip: builder.query({
      query: (token) => ({
        url: `salary/verify-payslip/${token}`,
        method: 'GET',
      }),
    }),
  }),
});

// ✅ Export hooks for usage in components
export const {
  useCreateSalarySlipMutation,
  useUpdateSettingsMutation,
  useGetPaySlipQuery,
  useLazyGetPaySlipQuery,
  useGetSalaryInformationMutation,
  useLazyCalculateSalaryQuery,
  useGetAllUsersSalariesQuery,
  useBulkSavePayDateMutation,
  useVerifyPayslipQuery,
  useLazyVerifyPayslipQuery,
} = salaryApi;
